import React, { useState } from "react";

const DisplayTBox = ({ answer, onAnswerChange }) => {
  const handleChange = (e) => {
    const newAnswer = e.target.value;
    onAnswerChange(newAnswer); // Call the callback function to update the 'answer' in the parent component
  };

  return (
    <>
      <input
        maxLength="11"
        className="border-solid border-black border-2 p-1 text-center justify-center"
        type="text"
        placeholder="Enter your answer"
        value={answer}
        onChange={handleChange}
      />
    </>
  );
};

export default DisplayTBox;
